@use 'cwc-header-v1';
@use 'cwc-header-v2';

cwc-header:not([v]) {
  @extend %cwc-header-v1;
}

cwc-header[v='2'] {
  @extend %cwc-header-v2;
}
